import React, { memo, useCallback } from 'react';

import { Field } from 'formik';
import { SelectProduct } from 'v2/components/Shared/FormFields/SelectProduct';

interface IProps {
  onChange?: (product_id: number) => void;
  onConfirm?: (product_id: number) => void;
}

const Fields = memo(({ onChange, onConfirm }: IProps) => {
  const handleOnConfirm = useCallback(
    (product: number) => {
      onChange?.(product);
      onConfirm?.(product);
    },
    [onChange, onConfirm]
  );

  return (
    <div className='flex justify-between'>
      <div className='w-full'>
        <Field
          id='product_id'
          name='product_id'
          onConfirm={handleOnConfirm}
          single
          fullWidth
          label='Produtos'
          component={SelectProduct}
          endpoint='reports/filter-all-products'
        />
      </div>
    </div>
  );
});

export default Fields;
